export const useQueryStringParsed = ({ search }: { search: string }) =>
  new URLSearchParams(search);
